import '@fancyapps/fancybox'

// Use jQuery to get lightbox class nodes.
const $lightboxInitiators = $('[data-fancybox], .lightbox')

// If there are lightbox DOM elements for lightbox, we initiate it.
if ($lightboxInitiators) {
    const config = {
        loop: true,
        infobar: false,
        smallBtn: true,
        toolbar: false,
        youtube: {
            controls: 1,
            showinfo: 0
        },
        btnTpl: {
            smallBtn: `
                <button class="btn-close" data-fancybox-close title="{{CLOSE}}">
                    <svg viewBox="0 0 83.2 83.2" preserveAspectRatio="xMinYMin meet" width="100%" height="100%">
                        <path d="M69.42 0L41.6 27.81 13.79 0 0 13.79 27.81 41.6 0 69.42 13.79 83.2 41.6 55.39 69.42 83.2 83.2 69.42 55.39 41.6 83.2 13.79 69.42 0z"></path>
                    </svg>
                </button>
            `,
            arrowLeft: `
                <button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left ArrowLink ArrowLink--left" title="{{PREV}}">
                    <svg class="ArrowLink-arrow" viewBox="0 0 64.9 100" width="100%" height="100%">
                        <path d="M15 0L0 15.1 34.8 50 0 84.9 15 100l49.9-50z"></path>
                    </svg>
                </button>
            `,
            arrowRight: `
                <button data-fancybox-next class="fancybox-button fancybox-button--arrow_right ArrowLink ArrowLink--right" title="{{NEXT}}">
                    <svg class="ArrowLink-arrow" viewBox="0 0 64.9 100" width="100%" height="100%">
                        <path d="M15 0L0 15.1 34.8 50 0 84.9 15 100l49.9-50z"></path>
                    </svg>
                </button>
            `
        }
    }

    $lightboxInitiators.fancybox(config)
}
